import React from 'react';
import { Avatar, Space, theme } from 'antd';

const { useToken } = theme;

// Maps a match result to its dot letter and theme colour token.
const resultConfig = {
    win: { letter: 'W', color: (token) => token.colorSuccess },
    lose: { letter: 'L', color: (token) => token.colorError },
    draw: { letter: 'D', color: (token) => token.colorWarning },
    tie: { letter: 'T', color: (token) => token.colorWarning },
    no_result: { letter: 'N', color: (token) => token.colorTextQuaternary },
    cancelled: { letter: 'C', color: (token) => token.colorTextQuaternary },
    abandoned: { letter: 'A', color: (token) => token.colorTextQuaternary },
};

const RecentForm = ({ results }) => {

    const { token } = useToken();

    if (!results || results.length === 0) {
        return null;
    }

    return (
        <Space size={4}>
            {results.map((result, index) => {
                const config = resultConfig[result] || resultConfig.no_result;
                return (
                    <Avatar
                        key={index}
                        size={16}
                        title={result}
                        style={{ backgroundColor: config.color(token), fontSize: 9 }}
                        >
                        {config.letter}
                    </Avatar>
                );
            })}
        </Space>
    );
};

export default RecentForm;
